import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FilterStatusesModel } from 'Pages/advertisement'

export type StatusesState = {
	filterStatuses: FilterStatusesModel[]
}

export const statusesInitialState: StatusesState = {
	filterStatuses: [],
}

export namespace statusesNS {
	export type GetFilterStatuses = PayloadAction
	export type SetFilterStatuses = PayloadAction<FilterStatusesModel[]>
}

export const statusesSlice = createSlice({
	name: 'statuses',
	initialState: statusesInitialState,
	reducers: {
		getFilterStatuses: (state, action: statusesNS.GetFilterStatuses) => {},
		setFilterStatuses: (state, action: statusesNS.SetFilterStatuses) => {
			state.filterStatuses = action.payload
		},
		clearFilterStatuses: (state) => {
			state.filterStatuses = []
		},
	},
})
